<template>
  <div>
    <div style="margin: 30px">
      <el-button type="success"   plain icon="el-icon-down" style="font-size: 14px" @click="downCommand">下载命令行工具</el-button>
    </div>
    <iframe style="width: 100%;border: none"  id="iframe" src="input/metabolome_16s-create.html" > </iframe>
  </div>
</template>

<script>
import {getDataInLocalStorage} from "@/utils/localStorageUtils";

const baseURL = process.env.VUE_APP_BASE_API

export default {
  name: "index",
  mounted() {
    const that=this
    var iframe = document.getElementById('iframe');
    iframe.addEventListener('load', function() {
      const height = this.contentWindow.document.body.scrollHeight +10+ 'px';
      this.style.height = height;
    });
  },
  methods:{
    downCommand(){
      // downloadFile('/static/raw-create.jar','raw-create.jar')  const url=`${baseURL}/preview/downloadReport/${this.analyzeId}?token=${getDataInLocalStorage("token")}`
      const url=`${baseURL}/version/jar/download/metabolome_16s-create.jar?token=${getDataInLocalStorage("token")}`
      console.log(url)
      const elink = document.createElement('a')
      elink.href = url
      document.body.appendChild(elink)
      elink.click()
    },
  }
}
</script>

<style scoped>
</style>
